function getDateInfo(dateString: string, opts?: Intl.DateTimeFormatOptions) {
  const monthsNames = ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];

  const date = new Date(dateString);
  const dateFormated = date.toLocaleString('default', opts);
  const dateMonth = (date.getMonth() + 1).toString().padStart(2, "0");
  const dateDay = (date.getDate() ).toString().padStart(2, "0");
  const dateTime = date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });

  return {
    dateMonth,
    dateDay,
    dateFormated,
    monthName: monthsNames[date.getMonth()],
    dateTime
  };
}

export default getDateInfo;
